import React from "react";
import { Navbar, Container } from "react-bootstrap";
import "../assets/css/header.css";

const Header = () => (
	<Navbar variant="dark" data-bs-theme="dark" sticky="top">
		<Container>
			<Navbar.Brand href="" target="_blank">
				<div className="logo"></div>
			</Navbar.Brand>
		</Container>
	</Navbar>
);

export default Header;
